import { useLang } from "../i18n";
import { Reveal, Overline } from "./Reveal";
import { useLightbox } from "./Lightbox";

const photos = [
  "/assets/gallery/booking/590200458.jpg",
  "/assets/gallery/booking/587280024.jpg",
  "/assets/gallery/booking/603829811.jpg",
  "/assets/gallery/booking/595219363.jpg",
  "/assets/gallery/booking/587280004.jpg",
  "/assets/gallery/booking/588937799.jpg",
  "/assets/gallery/booking/617348656.jpg",
  "/assets/gallery/booking/617348676.jpg",
  "/assets/gallery/booking/622173001.jpg",
  "/assets/gallery/booking/587279997.jpg",
  "/assets/gallery/booking/587280028.jpg",
  "/assets/gallery/booking/587280001.jpg",
  "/assets/gallery/booking/587280018.jpg",
  "/assets/gallery/booking/622172815.jpg",
  "/assets/gallery/booking/588938496.jpg",
  "/assets/gallery/booking/588938501.jpg",
  "/assets/gallery/booking/622172921.jpg",
  "/assets/gallery/booking/588956099.jpg",
  "/assets/gallery/booking/590200164.jpg",
  "/assets/gallery/booking/590200462.jpg",
  "/assets/gallery/booking/590200561.jpg",
  "/assets/gallery/booking/590200631.jpg",
];

const Gallery = () => {
  const { t } = useLang();
  const openLightbox = useLightbox();
  return (
    <section id="galleria" data-testid="gallery-section" className="py-28 lg:py-40 bg-[#E9EDF6]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <Reveal>
          <Overline>{t.gallery.overline}</Overline>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl tracking-tight mt-4 max-w-2xl">
            {t.gallery.title}
          </h2>
          <p className="mt-6 text-base md:text-lg text-[#14213D]/70 leading-relaxed max-w-xl">{t.gallery.desc}</p>
        </Reveal>

        <div className="mt-16 lg:mt-20 columns-2 md:columns-3 gap-4 [column-fill:balance]">
          {photos.map((src, i) => (
            <Reveal key={src} delay={(i % 3) * 0.08} className="mb-4 break-inside-avoid">
              <div className="overflow-hidden rounded-[1.25rem] group">
                <img
                  src={src}
                  alt={`King's Place — ${t.gallery.overline} ${i + 1}`}
                  loading="lazy"
                  data-testid={`gallery-photo-${i}`}
                  onClick={() => openLightbox(src, `King's Place — ${t.gallery.overline} ${i + 1}`)}
                  className="w-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out cursor-zoom-in"
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
